import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from '../../components/other/card/card'
import { Select } from 'antd'
import {
  useSubmitReportRequestMutation,
  useGetReportRequestsQuery
} from '../../redux/Api/AnalyticsApiSlice'
import Loader from '../pages/loader'
import { reportsAvailable } from './reportConfig'
import { useReportForm } from './useReportForm'
import ReportFormFields from './ReportFormFields'
import ReportRequestsTable from './ReportRequestsTable'
import { getUserId } from '../../helpers/auth'

function GenerateReports () {
  const [reportId, setReportId] = useState()
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const userID = getUserId()
  const [submitReportRequest, { isLoading: isSubmitting }] =
    useSubmitReportRequestMutation()
  const {
    data: reportRequests,
    isLoading: isLoadingRequests,
    isFetching,
    refetch
  } = useGetReportRequestsQuery({
    expand: [].join(','),
    user:userID,
    page: pagination.current,
    page_size: pagination.pageSize
  })

  const validation = useReportForm(reportId, setReportId, submitReportRequest)

  const handleTableChange = paginationInfo => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  const context = useContext(AppSettings)
  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return function cleanUp () {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [])

  return (
    <>
      <Card>
        <Loader isLoading={isSubmitting} />
        <CardHeader>Generate Reports</CardHeader>
        <CardBody>
          <div className=' mb-3'>
            <Select
              name='report_name'
              optionFilterProp='label'
              placeholder='Select Report'
              id='report_name'
              className={'customSelect'}
              showSearch
              style={{
                width: '100%'
              }}
              value={reportId}
              onChange={(e, option) => {
                setReportId(e)
                validation.setFieldValue('report_name', option.label)
              }}
              onBlur={validation.handleBlur}
              options={reportsAvailable?.map(x => {
                return { label: x.label, value: x.id }
              })}
            />
          </div>
          <ReportFormFields reportId={reportId} validation={validation} />
        </CardBody>
        <CardFooter>
          <button
            type='submit'
            className='btn btn-outline-theme'
            onClick={validation.handleSubmit}
            disabled={isSubmitting}
          >
            Generate
          </button>
        </CardFooter>
      </Card>
      <ReportRequestsTable
        reportRequests={reportRequests}
        isLoadingRequests={isLoadingRequests || isFetching}
        pagination={pagination}
        handleTableChange={handleTableChange}
        refetch={refetch}
      />
    </>
  )
}

export default GenerateReports
